import { type RefObject } from 'react';
import { useFittedPreviewBoardWidth } from '../common/useFittedPreviewBoardWidth';
import { COURSE_PREVIEW_BOARD_COUNT } from './coursePreviewBoardSizes';

/** Fit course preview miniboards to a card/container width (same caps as the courses hub). */
export const useFittedCoursePreviewBoardWidth = (
  containerRef: RefObject<HTMLElement | null>,
  boardCount = COURSE_PREVIEW_BOARD_COUNT,
): number => useFittedPreviewBoardWidth(containerRef, boardCount);
